export default __webpack_public_path__ + "static/media/TheNewYear_00.9ab42286.png";